import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../api";
import { useAuth } from "../auth";

const fmtDate = (d) =>
  new Date(d).toLocaleDateString(undefined, { month: "short", day: "numeric", year: "numeric" });

export default function Projects() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [projects, setProjects] = useState([]);
  const [clients, setClients] = useState([]);
  const [employees, setEmployees] = useState([]);
  const [creating, setCreating] = useState(false);
  const [form, setForm] = useState({ name: "", client_id: "", employee_ids: [] });

  const load = async () => {
    const { data } = await api.get("/projects");
    setProjects(data);
  };

  useEffect(() => {
    load();
    if (user?.role === "admin") {
      api.get("/users", { params: { role: "client" } }).then((r) => setClients(r.data));
      api.get("/users", { params: { role: "employee" } }).then((r) => setEmployees(r.data));
    }
  }, [user]);

  const submit = async (e) => {
    e.preventDefault();
    await api.post("/projects", {
      name: form.name,
      client_id: form.client_id ? Number(form.client_id) : null,
      employee_ids: form.employee_ids.map(Number),
    });
    setForm({ name: "", client_id: "", employee_ids: [] });
    setCreating(false);
    load();
  };

  const toggleEmp = (id) => {
    setForm((f) => ({
      ...f,
      employee_ids: f.employee_ids.includes(id)
        ? f.employee_ids.filter((x) => x !== id)
        : [...f.employee_ids, id],
    }));
  };

  return (
    <>
      <div className="page-head">
        <div className="title-block">
          <h1>Projects</h1>
        </div>
        {user?.role === "admin" && (
          <button className="primary" onClick={() => setCreating((c) => !c)}>
            {creating ? "Cancel" : "+ New project"}
          </button>
        )}
      </div>

      {creating && (
        <form className="card pad" onSubmit={submit} style={{ marginBottom: 16 }}>
          <div className="form-grid">
            <div>
              <label className="field">Project name</label>
              <input value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} required autoFocus />
            </div>
            <div>
              <label className="field">Client</label>
              <select value={form.client_id} onChange={(e) => setForm({ ...form, client_id: e.target.value })}>
                <option value="">— None —</option>
                {clients.map((c) => (
                  <option key={c.id} value={c.id}>{c.name} ({c.email})</option>
                ))}
              </select>
            </div>
            <div className="full">
              <label className="field">Employees</label>
              <div className="member-strip">
                {employees.length === 0 && <span className="muted-sm">No employees yet.</span>}
                {employees.map((e) => (
                  <label key={e.id} className="check-row">
                    <input
                      type="checkbox"
                      className="cbx"
                      checked={form.employee_ids.includes(e.id)}
                      onChange={() => toggleEmp(e.id)}
                    />
                    {e.name}
                  </label>
                ))}
              </div>
            </div>
            <div className="full" style={{ display: "flex", justifyContent: "flex-end", gap: 8 }}>
              <button type="button" onClick={() => setCreating(false)}>Cancel</button>
              <button type="submit" className="primary">Create project</button>
            </div>
          </div>
        </form>
      )}

      <div className="list">
        {projects.length === 0 ? (
          <div className="empty">
            Nothing here yet.
            <small>{user?.role === "admin" ? "Create your first project above." : "You'll see projects assigned to you here."}</small>
          </div>
        ) : (
          projects.map((p) => (
            <div
              key={p.id}
              className="row clickable"
              role="link"
              tabIndex={0}
              onClick={() => navigate(`/projects/${p.id}`)}
              onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") {
                  e.preventDefault();
                  navigate(`/projects/${p.id}`);
                }
              }}
            >
              <div className="lead">
                <span className="title">{p.name}</span>
              </div>
              <div className="meta">
                <span>Created {fmtDate(p.created_at)}</span>
              </div>
            </div>
          ))
        )}
      </div>
    </>
  );
}
